<form [formGroup]="kidForm" (ngSubmit)="kidSubmit()" class="dialog">
    <igx-input-group type="border">
        <label igxLabel>Име и фамилия на детето</label>
        <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
        <igx-hint *ngIf="request?.kidName && kid">{{ request?.kidName }}</igx-hint>
    </igx-input-group>
    <igx-date-picker name="birthDate" formControlName="birthDate" type="border">
        <label igxLabel>Дата на раждане</label>
        <igx-hint *ngIf="request?.kidBirth && kid">{{ request?.kidBirth | date: "dd.MM.yyyy г." }}</igx-hint>
    </igx-date-picker>
    <igx-radio-group name="gender" formControlName="gender" type="border" class="row">
        <igx-radio value="m">М</igx-radio>
        <igx-radio value="f">Ж</igx-radio>
    </igx-radio-group>
    <igx-select name="footSize" formControlName="footSize" type="border">
        <label igxLabel>Обувки №</label>
        <igx-select-item *ngFor="let size of shoeSizes" [value]="size">
            {{size }}
        </igx-select-item>
        <igx-suffix *ngIf="kidForm.controls.footSize.value">
            <igx-icon (click)="clearSelection($event, kidForm.controls.footSize)">cancel</igx-icon>
        </igx-suffix>
        <igx-hint *ngIf="request?.kidFootSize && kid">{{ request?.kidFootSize }}</igx-hint>
    </igx-select>
    <igx-input-group type="border">
        <label igxLabel>Височина</label>
        <input igxInput [igxTextSelection]="true" name="height" formControlName="height" />
        <igx-hint *ngIf="request?.kidHeight && kid">{{ request?.kidHeight }}</igx-hint>
    </igx-input-group>
    <div class="row">
        <igx-checkbox name="hasDeclaration" formControlName="hasDeclaration" type="border">Декларация</igx-checkbox>
        <igx-checkbox name="allowShooting" formControlName="allowShooting" type="border">Снимки</igx-checkbox>
    </div>
    <igx-input-group type="border">
        <label igxLabel>Бележки</label>
        <textarea igxInput [igxTextSelection]="true" name="notes" formControlName="notes"></textarea>
    </igx-input-group>
    <igx-combo name="friends" formControlName="friends" type="border" [data]="kids" [displayKey]="'name'" [valueKey]="'id'">
        <label igxLabel>Приятели</label>
    </igx-combo>
    <igx-combo name="siblings" formControlName="siblings" type="border" [data]="kids" [displayKey]="'name'" [valueKey]="'id'">
        <label igxLabel>Роднини</label>
    </igx-combo>
    <igx-combo name="parents" formControlName="parents" type="border" [data]="parents | sorting" [displayKey]="'name'" [valueKey]="'id'">
        <label igxLabel>Родители</label>
        <igx-suffix>
            <button type="button" igxIconButton="flat" (click)="addParent($event, parentForm, addParentDialog)" title="Добави родител">
                <igx-icon>person_add</igx-icon>
            </button>
        </igx-suffix>
    </igx-combo>
    <igx-input-group type="border">
        <label igxLabel>ЕГН</label>
        <input igxInput [igxTextSelection]="true" name="egn" formControlName="egn" />
    </igx-input-group>
    <igx-select name="morningStop" formControlName="morningStop" type="border">
        <label igxLabel>Спирка сутрин</label>
        <igx-select-item *ngFor="let stop of stops | sorting" [value]="stop.id">
            {{ parseStop(stop) }}
        </igx-select-item>
        <igx-suffix *ngIf="kidForm.controls.morningStop.value">
            <igx-icon (click)="clearSelection($event, kidForm.controls.morningStop)">cancel</igx-icon>
        </igx-suffix>
        <igx-hint *ngIf="request?.stopMorning && kid">{{ parseStop(request?.stopMorning) }}</igx-hint>
    </igx-select>
    <igx-select name="eveningStop" formControlName="eveningStop" type="border">
        <label igxLabel>Спирка вечер</label>
        <igx-select-item *ngFor="let stop of stops | sorting" [value]="stop.id">
            {{ parseStop(stop) }}
        </igx-select-item>
        <igx-suffix *ngIf="kidForm.controls.eveningStop.value">
            <igx-icon (click)="clearSelection($event, kidForm.controls.eveningStop)">cancel</igx-icon>
        </igx-suffix>
        <igx-hint *ngIf="request?.stopMorning && kid">{{ parseStop(request?.stopMorning) }}</igx-hint>
    </igx-select>
    <igx-dialog-actions>
        <button igxButton type="button" (click)="done.emit(undefined)">ОТКАЖИ</button>
        <button igxButton type="submit">{{ dialogText }}</button>
    </igx-dialog-actions>
</form>

<igx-dialog #addParentDialog>
    <igx-dialog-title>Добави родител</igx-dialog-title>
    <app-edit-parent-form #parentForm [parent]="undefined" (done)="saveParentDone($event, addParentDialog)"></app-edit-parent-form>
</igx-dialog>
